import { render, staticRenderFns } from "./change_back.vue?vue&type=template&id=65c0bd8b&scoped=true"
import script from "./change_back.vue?vue&type=script&lang=js"
export * from "./change_back.vue?vue&type=script&lang=js"
import style0 from "./change_back.vue?vue&type=style&index=0&id=65c0bd8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c0bd8b",
  null
  
)

export default component.exports